import styled from 'styled-components';

import { SmallParagraph } from '../../../foundations/typefaces/SmallParagraph';
import style from '../../../style';
import type { Color } from '../../../style/types/theme';
import { Variant } from './types';

interface WrapperProps {
  $variant: Variant;
}

const getIconColorsByVariant = (variant: Variant, color: Color) => {
  const colorsByVariant = {
    [Variant.INFO]: {
      color: color.content.info.contrast(),
      background: color.background.info.default(),
    },
    [Variant.WARNING]: {
      color: color.content.warning.contrast(),
      background: color.background.warning.default(),
    },
    [Variant.ERROR]: {
      color: color.content.error.contrast(),
      background: color.background.error.default(),
    },
    [Variant.SUCCESS]: {
      color: color.content.success.contrast(),
      background: color.background.success.default(),
    },
  };

  return colorsByVariant[variant];
};

export const IconTextWrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  gap: size.units(1),
}));

export const IconWrapper = styled.div({
  display: 'flex',
  justifyContent: 'flex-start',
  alignSelf: 'center',
});

export const StyledSmallParagrap = styled(SmallParagraph)(({ theme: { color } }) => ({
  color: color.content.primary.default(),
  cursor: 'default',

  ...style.mixins.increaseSpecificity({
    a: {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  }),
}));

export const Wrapper = styled.div<WrapperProps>(
  ({ $variant, theme: { size, color } }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: `${size.units(1)} ${size.units(2)}`,
    background: getIconColorsByVariant($variant, color).background,
    borderRadius: size.units(1),
    width: '100%',
    height: 'auto',
    justifyContent: 'space-between',

    [IconWrapper]: {
      color: getIconColorsByVariant($variant, color).color,
    },
  }),
);

export const ContentWrapper = styled.div(() => ({
  display: 'flex',
}));
